<template>
  <v-row>
    <v-col cols="12">
      <v-autocomplete
        v-if="field.canRead"
        ref="multiSelect"
        v-model="selected"
        :items="optionsComputed"
        :label="labelText"
        :menu-props="{ closeOnClick: false, closeOnContentClick: false }"
        :disabled="!field.canEdit"
        item-text="text"
        item-value="value"

        :rounded="cs.inputRounded"
        :dense="cs.inputDense"
        :outlined="cs.inputOutlined"
        :filled="cs.inputFilled"
        :background-color="fieldBackgroundColor(value[field.fieldName].length > 0, field)"

        @change="addMultiLinkSelected(field.fieldName)"
      ></v-autocomplete>
    </v-col>
    <template v-if="value[field.fieldName] && field.canRead">
      <template
        v-for="(multiLinkSelected, mls_index) in value[field.fieldName]"

      >
        <v-col cols="8">
          {{
            multiLinkSelected[field.info.linkModuleDisplayField] ? multiLinkSelected[field.info.linkModuleDisplayField] : (
              multiLinkSelected[field.info.linkModuleDisplayField + '_en'] ? multiLinkSelected[field.info.linkModuleDisplayField + '_en'] : ''
            ) }}
        </v-col>
        <v-col cols="4">
          <v-icon @click="removeOption(mls_index)">fa-times</v-icon>
        </v-col>
      </template>
    </template>
    </v-col>
  </v-row>
</template>

<script>
import sharedComputed from './../../computed'
import sharedMethods from './../../methods'
import formElementProps from './formElementProps'

export default {
  name: 'FormMultiLink',

  data () {
    return {
      selected: null
    }
  },

  props: {
    ...formElementProps,

    linkOptions: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  created () {
    if (!this.value[this.field.fieldName]) {
      this.value[this.field.fieldName] = []
    }
  },

  computed: {
    ...sharedComputed,

    optionsComputed () {
      let currentlySelectedById = []
      if (!this.value || !this.field || !this.field.fieldName ||
        !this.value[this.field.fieldName]
      ) {
        return this.linkOptions[this.field.fieldName]
      }
      this.value[this.field.fieldName].forEach(selected => {
        currentlySelectedById[selected._id] = selected
      })
      return this.linkOptions[this.field.fieldName].filter(option => !currentlySelectedById[option.info._id])
    }
  },

  methods: {
    ...sharedMethods,

    removeOption (index) {
      this.value[this.field.fieldName].splice(index, 1)
    },

    addMultiLinkSelected (option) {
      if (!this.value[this.field.fieldName]) {
        this.value[this.field.fieldName] = []
      }
      let selectedOption = this.linkOptions[this.field.fieldName].find(option => option.info._id === this.selected)
      this.value[this.field.fieldName].push(selectedOption.info)
      // TODO - would be good to leave it open
      //this.$refs.multiSelect.blur()
      //console.log(this.$refs.multiSelect.$el)
      //this.$nextTick(() => {
      //  this.$refs.multiSelect.$el.click()
      //})
    }
  }
}
</script>
